import { FC, memo, useContext } from 'react';

import { useQuery } from '@apollo/client';
import { Label } from '@smartshell/ui-kit';

import { AuthContext } from 'auth';
import { ClientsAvatar } from 'components';
import { LocalizationContext } from 'localization';
import {
  GET_WORKSHIFT_MONEY,
  IGetWorkShiftMoneyRequest,
  IGetWorkShiftMoneyResponse,
} from 'schemas';
import { formatFIO, formatPhone } from 'utils';

import s from './CurrentOperator.module.scss';

export const CurrentOperator: FC = memo(() => {
  const { t } = useContext(LocalizationContext);
  const {
    data: { me, permissions },
  } = useContext(AuthContext);

  const { data: workshiftMoneyData } = useQuery<
    IGetWorkShiftMoneyResponse,
    IGetWorkShiftMoneyRequest
  >(GET_WORKSHIFT_MONEY, {
    fetchPolicy: 'cache-and-network',
    skip: !permissions?.has('work_shift_active'),
  });

  const currentOperator =
    workshiftMoneyData?.getWorkShiftPaymentOverviewData?.worker;

  if (!currentOperator || !me) {
    return null;
  }

  if (currentOperator.uuid === me.uuid) return null;

  return (
    <div className={s.container}>
      <ClientsAvatar
        avatar={currentOperator?.avatar_url}
        roles={currentOperator?.roles}
        size="s"
      />

      <div className={s.data}>
        <span className={s.fio}>{formatFIO(currentOperator)}</span>
        <span className={s.phone}>{formatPhone(currentOperator.phone)}</span>
      </div>
      <Label
        text={t('workShifts.status.onShift')}
        color="gray-secondary"
        rounded
        className={s.label}
      />
    </div>
  );
});
